<template>
    <div>
        <transition name="slide-fade" appear>
            <b-card v-if="this.$store.state.preMatricula">
                <form-wizard @on-complete="onComplete" title="Ficha Matricula Año Lectivo 2021" subtitle="Formulario de Actualización de Datos del Estudiante" back-button-text="Anterior" next-button-text="Siguiente" finish-button-text="Terminar">
                    <tab-content title="Datos del Estudiante" icon="fas fa-user" :before-change="validarDatosEstudiante">
                        <b-card>
                            <b-row>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Nombres del Estudiante *" label-for="nombrese" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.nombres" id="nombrese" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Apellidos del Estudiante *" label-for="apellidose" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.apellidos" id="apellidose" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="3" class="mt-3">
                                    <b-form-group label="Nacionalidad *" label-for="nacionalidad" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_nacionalidad" :options="listaPaises" id="nacionalidad">
                                            <template slot="first"><option :value="null" disabled>-- Nacionalidad --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorNacionalidad }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="3" class="mt-3">
                                    <b-form-group label="No. Documento *" label-for="documentoe" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.documento" id="documentoe" disabled></b-form-input>
                                        <span class="text-left text-danger">{{ errorDocumentoE }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="2" md="2" class="mt-3">
                                    <b-form-group label="Tipo *" label-for="tipo" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_tipo_documento" :options="listaTiposDocumentos" id="tipo">
                                            <template slot="first"><option :value="null" disabled>-- Tipo documento --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorTipo }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="4" md="4" class="mt-3">
                                    <b-form-group label="Municipio Expedición *" label-for="municipiodoc" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_municipio_documento" :options="listaMunicipios" id="municipiodoc">
                                            <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorMunicipioDoc }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <label style="font-weight: bold">Fecha de Nacimiento *</label>
                                    <b-row>
                                        <b-col lg="3" md="3">
                                            <b-form-group label="Día" label-cols-lg="4" label-cols-md="4">
                                                <b-form-select v-model="diaNace" :options="listaDias" id="dia">
                                                    <template slot="first"><option :value="null" disabled>--</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger" style="font-weight: bold">{{ errorDia }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="5" md="5">
                                            <b-form-group label="Mes" label-cols-lg="3" label-cols-md="3">
                                                <b-form-select v-model="mesNace" :options="listaMeses" id="mes">
                                                    <template slot="first"><option :value="null" disabled>--</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger" style="font-weight: bold">{{ errorMes }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="4" md="4">
                                            <b-form-group label="Año" label-cols-lg="4" label-cols-md="4">
                                                <b-form-select v-model="anoNace" :options="listaAnos" id="ano">
                                                    <template slot="first"><option :value="null" disabled>----</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger" style="font-weight: bold">{{ errorAno }}</span>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col lg="4" md="4" class="mt-3">
                                    <b-form-group label="Municipio Nacimiento *" label-for="municipionac" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_municipio_nacimiento" :options="listaMunicipios" id="municipionac">
                                            <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorMunicipioNac }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="2" md="2" class="mt-3">
                                    <b-form-group label="Genero *" label-for="genero" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_genero" :options="listaGeneros" id="genero">
                                            <template slot="first"><option :value="null" disabled>-- Genero --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorGenero }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="3" class="mt-3">
                                    <b-form-group label="Grupo Sanguineo *" label-for="rh" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_rh" :options="listaRhs" id="rh">
                                            <template slot="first"><option :value="null" disabled>-- Rh --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorRh }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="3" class="mt-3">
                                    <b-form-group label="Grupo Etnico *" label-for="etnia" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_etnia" :options="listaEtnias" id="etnia">
                                            <template slot="first"><option :value="null" disabled>-- Etnia --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorEtnia }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Limitación - Discapacidad *" label-for="limitacion" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_discapacidad" :options="listaLimitaciones" id="limitacion">
                                            <template slot="first"><option :value="null" disabled>-- Limitación --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorLimitacion }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Capacidades Excepcionales *" label-for="capacidad" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_capacidad" :options="listaCapacidades" id="capacidad">
                                            <template slot="first"><option :value="null" disabled>-- Capacidad Excepcional --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorCapacidad }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="3" class="mt-3">
                                    <b-form-group label="Estrato *" label-for="estrato" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_estrato" :options="listaEstratos" id="estrato">
                                            <template slot="first"><option :value="null" disabled>-- Estrato --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorEstrato }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3" md="3" class="mt-3">
                                    <b-form-group label="Puntaje Sisben *" label-for="sisben" style="font-weight: bold">
                                        <b-form-input type="number" v-model="datosEstudiante.sisben" id="sisben" autocomplete="off" maxlength="5"></b-form-input>
                                        <span class="text-left text-danger">{{ errorSisben }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Población Victima del Conflicto *" label-for="victima" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_victima" :options="listaVictimas" id="victima">
                                            <template slot="first"><option :value="null" disabled>-- Victima --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorVictima }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Entidad a la que está afiliado - EPS *" label-for="eps" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.eps" id="eps" autocomplete="off" maxlength="50"></b-form-input>
                                        <span class="text-left text-danger">{{ errorEps }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="12" md="12" class="mt-3">
                                    <b-form-group label="Describa si tiene alguna enfermedad, tratamiento especial o alergia" label-for="enfermedad" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.enfermedades" id="enfermedad" autocomplete="off" maxlength="255"></b-form-input>
                                        <span class="text-left text-danger">{{ errorEnfermedad }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Dirección de Residencia *" label-for="direccionE" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.direccion_estudiante" id="direccionE" autocomplete="off" maxlength="100"></b-form-input>
                                        <span class="text-left text-danger">{{ errorDireccionE }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Municipio de Residencia *" label-for="municipiodirE" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_municipio_direccion_estudiante" :options="listaMunicipios" id="municipiodirE">
                                            <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorMunicipioDirE }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Teléfonos *" label-for="telefonoE" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.telefono_estudiante" id="telefonoE" autocomplete="off" maxlength="50"></b-form-input>
                                        <span class="text-left text-danger">{{ errorTelefonoE }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Correo Electrónico *" label-for="correoE" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.correo_estudiante" id="correoE" autocomplete="off" maxlength="100"></b-form-input>
                                        <span class="text-left text-danger">{{ errorCorreoE }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col><h6 class="text-primary">Los campos marcados con * son obligatorios.</h6></b-col>
                            </b-row>
                        </b-card>
                    </tab-content>
                    <tab-content title="Datos Familiares" icon="fas fa-user" :before-change="validarDatosFamiliares">
                        <b-card>
                            <b-row>
                                <b-col cols="6">
                                    <h3 class="text-info">Datos del Papá</h3><hr>
                                    <b-row>
                                        <b-col lg="5" md="5" class="mt-3">
                                            <b-form-group label="Cédula del Papá *" label-for="documentop" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.documento_papa" id="documentop" autocomplete="off" maxlength="15"></b-form-input>
                                                <span class="text-left text-danger">{{ errorDocumentoP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="7" md="7" class="mt-3">
                                            <b-form-group label="Municipio Expedición *" label-for="municipiodocp" style="font-weight: bold">
                                                <b-form-select v-model="datosEstudiante.id_municipio_documento_papa" :options="listaMunicipios" id="municipiodocp">
                                                    <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger">{{ errorMunicipioDocP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Nombres del Papá *" label-for="nombresp" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.nombres_papa" id="nombresp" autocomplete="off" maxlength="25"></b-form-input>
                                                <span class="text-left text-danger">{{ errorNombresP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Apellidos del Papá *" label-for="apellidosp" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.apellidos_papa" id="apellidosp" autocomplete="off" maxlength="25"></b-form-input>
                                                <span class="text-left text-danger">{{ errorApellidosP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <label style="font-weight: bold">Fecha de Nacimiento del Papá *</label>
                                            <b-row>
                                                <b-col lg="3" md="3">
                                                    <b-form-group label="Día" label-cols-lg="4" label-cols-md="4">
                                                        <b-form-select v-model="diaNaceP" :options="listaDias" id="diaP">
                                                            <template slot="first"><option :value="null" disabled>--</option></template>
                                                        </b-form-select>
                                                        <span class="text-left text-danger" style="font-weight: bold">{{ errorDiaP }}</span>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="5" md="5">
                                                    <b-form-group label="Mes" label-cols-lg="3" label-cols-md="3">
                                                        <b-form-select v-model="mesNaceP" :options="listaMeses" id="mesP">
                                                            <template slot="first"><option :value="null" disabled>--</option></template>
                                                        </b-form-select>
                                                        <span class="text-left text-danger" style="font-weight: bold">{{ errorMesP }}</span>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4">
                                                    <b-form-group label="Año" label-cols-lg="4" label-cols-md="4">
                                                        <b-form-select v-model="anoNaceP" :options="listaAnos" id="anoP">
                                                            <template slot="first"><option :value="null" disabled>----</option></template>
                                                        </b-form-select>
                                                        <span class="text-left text-danger" style="font-weight: bold">{{ errorAnoP }}</span>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Dirección de Residencia del Papá *" label-for="direccionP" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.direccion_papa" id="direccionP" autocomplete="off" maxlength="100"></b-form-input>
                                                <span class="text-left text-danger">{{ errorDireccionP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Municipio de Residencia del Papá *" label-for="municipiodirP" style="font-weight: bold">
                                                <b-form-select v-model="datosEstudiante.id_municipio_direccion_papa" :options="listaMunicipios" id="municipiodirP">
                                                    <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger">{{ errorMunicipioDirP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Teléfonos del Papá *" label-for="telefonoP" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.telefono_papa" id="telefonoP" autocomplete="off" maxlength="50"></b-form-input>
                                                <span class="text-left text-danger">{{ errorTelefonoP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Correo Electrónico del Papá *" label-for="correoP" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.correo_papa" id="correoP" autocomplete="off" maxlength="100"></b-form-input>
                                                <span class="text-left text-danger">{{ errorCorreoP }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Actividad Laboral del Papá - Empresa *" label-for="actividadP" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.actividad_papa" id="actividadP" autocomplete="off" maxlength="50"></b-form-input>
                                                <span class="text-left text-danger">{{ errorActividadP }}</span>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="6">
                                    <h3 class="text-info">Datos de la Mamá</h3><hr>
                                    <b-row>
                                        <b-col lg="5" md="5" class="mt-3">
                                            <b-form-group label="Cédula de la Mamá *" label-for="documentom" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.documento_mama" id="documentom" autocomplete="off" maxlength="15"></b-form-input>
                                                <span class="text-left text-danger">{{ errorDocumentoM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="7" md="7" class="mt-3">
                                            <b-form-group label="Municipio Expedición *" label-for="municipiodocm" style="font-weight: bold">
                                                <b-form-select v-model="datosEstudiante.id_municipio_documento_mama" :options="listaMunicipios" id="municipiodocm">
                                                    <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger">{{ errorMunicipioDocM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Nombres de la Mamá *" label-for="nombresm" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.nombres_mama" id="nombresm" autocomplete="off" maxlength="25"></b-form-input>
                                                <span class="text-left text-danger">{{ errorNombresM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Apellidos de la Mamá *" label-for="apellidosm" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.apellidos_mama" id="apellidosm" autocomplete="off" maxlength="25"></b-form-input>
                                                <span class="text-left text-danger">{{ errorApellidosM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <label style="font-weight: bold">Fecha de Nacimiento de la Mamá *</label>
                                            <b-row>
                                                <b-col lg="3" md="3">
                                                    <b-form-group label="Día" label-cols-lg="4" label-cols-md="4">
                                                        <b-form-select v-model="diaNaceM" :options="listaDias" id="diaM">
                                                            <template slot="first"><option :value="null" disabled>--</option></template>
                                                        </b-form-select>
                                                        <span class="text-left text-danger" style="font-weight: bold">{{ errorDiaM }}</span>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="5" md="5">
                                                    <b-form-group label="Mes" label-cols-lg="3" label-cols-md="3">
                                                        <b-form-select v-model="mesNaceM" :options="listaMeses" id="mesM">
                                                            <template slot="first"><option :value="null" disabled>--</option></template>
                                                        </b-form-select>
                                                        <span class="text-left text-danger" style="font-weight: bold">{{ errorMesM }}</span>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4">
                                                    <b-form-group label="Año" label-cols-lg="4" label-cols-md="4">
                                                        <b-form-select v-model="anoNaceM" :options="listaAnos" id="anoM">
                                                            <template slot="first"><option :value="null" disabled>----</option></template>
                                                        </b-form-select>
                                                        <span class="text-left text-danger" style="font-weight: bold">{{ errorAnoM }}</span>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Dirección de Residencia de la Mamá *" label-for="direccionM" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.direccion_mama" id="direccionM" autocomplete="off" maxlength="100"></b-form-input>
                                                <span class="text-left text-danger">{{ errorDireccionM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Municipio de Residencia de la Mamá *" label-for="municipiodirM" style="font-weight: bold">
                                                <b-form-select v-model="datosEstudiante.id_municipio_direccion_mama" :options="listaMunicipios" id="municipiodirM">
                                                    <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger">{{ errorMunicipioDirM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Teléfonos de la Mamá *" label-for="telefonoM" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.telefono_mama" id="telefonoM" autocomplete="off" maxlength="50"></b-form-input>
                                                <span class="text-left text-danger">{{ errorTelefonoM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Correo Electrónico de la Mamá *" label-for="correoM" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.correo_mama" id="correoM" autocomplete="off" maxlength="100"></b-form-input>
                                                <span class="text-left text-danger">{{ errorCorreoM }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="mt-3">
                                            <b-form-group label="Actividad Laboral de la Mamá - Empresa *" label-for="actividadM" style="font-weight: bold">
                                                <b-form-input type="text" v-model="datosEstudiante.actividad_mama" id="actividadM" autocomplete="off" maxlength="50"></b-form-input>
                                                <span class="text-left text-danger">{{ errorActividadM }}</span>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col><h6 class="text-primary">Los campos marcados con * son obligatorios.</h6></b-col>
                            </b-row>
                        </b-card>
                    </tab-content>
                    <tab-content title="Datos del Acudiente" icon="fas fa-user" :before-change="validarDatosAcudiente">
                        <b-card>
                            <b-row>
                                <b-col lg="6" md="6" class="mt-3">
                                    <p>Seleccione el parentesco que existe entre el acudiente y el estudiante. Si el acudiente no es el Papá o la Mamá, debe diligenciar los datos de la persona que va a ser el acudiente.</p>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Parentesco *" label-for="parentesco" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_parentesco" :options="listaParentescos" id="parentesco" @change="reseteoCamposAcudiente(), validarParentesco()">
                                            <template slot="first"><option :value="null" disabled>-- Parentesco --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorParentesco }}</span>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="verFichaAcudiente">
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Cédula del Acudiente *" label-for="documentoa" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.documento_acudiente" id="documentoa" autocomplete="off" maxlength="15" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorDocumentoA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Municipio Expedición *" label-for="municipiodoca" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_municipio_documento_acudiente" :options="listaMunicipios" id="municipiodoca" :disabled='inhabilitarCampo'>
                                            <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorMunicipioDocA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Nombres del Acudiente *" label-for="nombresa" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.nombres_acudiente" id="nombresa" autocomplete="off" maxlength="25" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorNombresA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Apellidos del Acudiente *" label-for="apellidosa" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.apellidos_acudiente" id="apellidosa" autocomplete="off" maxlength="25" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorApellidosA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <label style="font-weight: bold">Fecha de Nacimiento del Acudiente *</label>
                                    <b-row>
                                        <b-col lg="3" md="3">
                                            <b-form-group label="Día" label-cols-lg="4" label-cols-md="4">
                                                <b-form-select v-model="diaNaceA" :options="listaDias" id="diaA" :disabled='inhabilitarCampo'>
                                                    <template slot="first"><option :value="null" disabled>--</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger" style="font-weight: bold">{{ errorDiaA }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="5" md="5">
                                            <b-form-group label="Mes" label-cols-lg="3" label-cols-md="3">
                                                <b-form-select v-model="mesNaceA" :options="listaMeses" id="mesA" :disabled='inhabilitarCampo'>
                                                    <template slot="first"><option :value="null" disabled>--</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger" style="font-weight: bold">{{ errorMesA }}</span>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="4" md="4">
                                            <b-form-group label="Año" label-cols-lg="4" label-cols-md="4" :disabled='inhabilitarCampo'>
                                                <b-form-select v-model="anoNaceA" :options="listaAnos" id="anoA">
                                                    <template slot="first"><option :value="null" disabled>----</option></template>
                                                </b-form-select>
                                                <span class="text-left text-danger" style="font-weight: bold">{{ errorAnoA }}</span>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Actividad Laboral del Acudiente - Empresa *" label-for="actividadA" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.actividad_acudiente" id="actividadA" autocomplete="off" maxlength="50" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorActividadA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Dirección de Residencia del Acudiente *" label-for="direccionA" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.direccion_acudiente" id="direccionA" autocomplete="off" maxlength="100" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorDireccionA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Municipio de Residencia del Acudiente *" label-for="municipiodirA" style="font-weight: bold">
                                        <b-form-select v-model="datosEstudiante.id_municipio_direccion_acudiente" :options="listaMunicipios" id="municipiodirA" :disabled='inhabilitarCampo'>
                                            <template slot="first"><option :value="null" disabled>-- Municipio --</option></template>
                                        </b-form-select>
                                        <span class="text-left text-danger">{{ errorMunicipioDirA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Teléfonos del Acudiente *" label-for="telefonoA" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.telefono_acudiente" id="telefonoA" autocomplete="off" maxlength="50" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorTelefonoA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6" md="6" class="mt-3">
                                    <b-form-group label="Correo Electrónico del Acudiente *" label-for="correoA" style="font-weight: bold">
                                        <b-form-input type="text" v-model="datosEstudiante.correo_acudiente" id="correoA" autocomplete="off" maxlength="100" :disabled='inhabilitarCampo'></b-form-input>
                                        <span class="text-left text-danger">{{ errorCorreoA }}</span>
                                    </b-form-group>
                                </b-col>
                                <b-col><h6 class="text-primary">Los campos marcados con * son obligatorios.</h6></b-col>
                            </b-row>
                        </b-card>
                    </tab-content>
                    <tab-content title="Matricular" icon="fas fa-bell">
                        <b-card v-if="!terminarMatricula">
                            <b-row>
                                <b-col class="text-center">
                                    <h5 class="text-warning">El formulario de actualización de datos se ha diligenciado correctamente.</h5>
                                    <hr>
                                    <h3 class="mt-4"><strong>MATRICULA AÑO LECTIVO 2021</strong></h3>
                                    <h6 class="mt-4 mb-4">Al realizar la matricula en línea, está reservando un cupo para continuar estudiando en la institución.</h6>
                                    <h6 class="mt-4 mb-4">Para finalizar el proceso de matricula haga clic en el botón Matricular Estudiante.</h6>
                                    <h6 class="mt-4 mb-4"><strong>Con la presente matricula el estudiante, padres de familia y acudiente aceptan las normas, acuerdos y reglamentos para la convivencia escolar, establecidos en la Institución Educativa.</strong></h6>
                                    <div>
                                        <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" value="Aceptamos" unchecked-value="No estamos de acuerdo">
                                        <strong>Aceptamos</strong>
                                        </b-form-checkbox>
                                    </div>
                                    <h1><i class="fas fa-chevron-down"></i></h1>
                                    <b-button size="lg" variant="success" @click="preMatricularEstudiante" :disabled="status==='Aceptamos' ? false : true">Matricular Estudiante</b-button>
                                    <br><br><br><br><br><br><br><br>
                                </b-col>
                            </b-row>
                        </b-card>
                        <b-card v-else>
                            <b-row>
                                <b-col class="text-center">
                                    <h1 class="text-info">Gracias por matricularte.</h1>
                                    <hr>
                                    <h1 class="m-5"><i class="far fa-thumbs-up"></i></h1>
                                    <b-button size="lg" variant="primary" @click="onComplete">Terminar</b-button>
                                    <br><br><br><br><br><br><br><br>
                                </b-col>
                            </b-row>
                        </b-card>
                    </tab-content>
                </form-wizard>
            </b-card>
            <b-card v-else>
                <b-row>
                    <b-col class="text-center mt-5">
                        <h1><i class="fas fa-laptop-house"></i></h1><br><br>
                        <h2 class="text-info">Ups, lo sentimos.</h2>
                        <h4>En el momento no está habilitada la matricula en línea para el año 2021.</h4>
                        <h4>La institución les informará al momento de habilitar éste proceso.</h4>
                        <b-button class="m-5" size="lg" variant="primary" @click="onComplete">Ir al inicio</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </transition>
    </div>
</template>

<script>
    import axios from "axios"
    import * as CONFIG from '@/assets/config.js'
    import { validationMixin } from "vuelidate"
    import { required, minLength } from "vuelidate/lib/validators"

    import paises from "@/assets/tablas/paises.js"
    import municipios from "@/assets/tablas/municipios.js"
    import documentos from "@/assets/tablas/documentos.js"
    import rhs from "@/assets/tablas/rhs.js"
    import generos from "@/assets/tablas/generos.js"
    import etnias from "@/assets/tablas/etnias.js"
    import limitaciones from "@/assets/tablas/limitaciones.js"
    import victimas from "@/assets/tablas/victimas.js"
    import parentescos from "@/assets/tablas/parentescos.js"

    export default {
        mixins: [validationMixin],
        name: 'Matricula2021',
        data() {
            return {
                datosEstudiante: {},
                listaNacionalidades: [
                    { value: 1, text: 'COLOMBIANA' },
                    { value: 2, text: 'VENEZOLANA' }
                ],
                listaTiposDocumentos: [],
                listaPaises: [],
                listaMunicipios: [],
                listaGeneros: [],
                listaDias: [],
                listaMeses: [
                    { value: 1, text: 'ENERO' },
                    { value: 2, text: 'FEBRERO' },
                    { value: 3, text: 'MARZO' },
                    { value: 4, text: 'ABRIL' },
                    { value: 5, text: 'MAYO' },
                    { value: 6, text: 'JUNIO' },
                    { value: 7, text: 'JULIO' },
                    { value: 8, text: 'AGOSTO' },
                    { value: 9, text: 'SEPTIEMBRE' },
                    { value: 10, text: 'OCTUBRE' },
                    { value: 11, text: 'NOVIEMBRE' },
                    { value: 12, text: 'DICIEMBRE' }
                ],
                listaAnos: [],
                listaRhs: [],
                listaEtnias: [],
                listaLimitaciones: [],
                listaCapacidades: [
                    { value: 1, text: 'NO APLICA' },
                    { value: 2, text: 'CUENTA CON CAPACIDADES EXCEPCIONALES' }
                ],
                listaVictimas: [],
                listaEstratos: [],
                errorNombresE: '',
                errorApellidosE: '',
                errorNacionalidad: '',
                errorDocumentoE: '',
                errorTipo: '',
                errorMunicipioDoc: '',
                errorDia: '',
                errorMes: '',
                errorAno: '',
                errorMunicipioNac: '',
                errorGenero: '',
                errorRh: '',
                errorEtnia: '',
                errorLimitacion: '',
                errorVictima: '',
                errorCapacidad: '',
                errorEstrato: '',
                errorSisben: '',
                errorEps: '',
                errorEnfermedad: '',
                errorDireccionE: '',
                errorMunicipioDirE: '',
                errorTelefonoE: '',
                errorCorreoE: '',
                diaNace: null,
                mesNace: null,
                anoNace: null,
                errorDocumentoP: '',
                errorDocumentoM: '',
                errorMunicipioDocP: '',
                errorMunicipioDocM: '',
                errorNombresP: '',
                errorNombresM: '',
                errorApellidosP: '',
                errorApellidosM: '',
                errorDiaP: '',
                errorMesP: '',
                errorAnoP: '',
                errorDiaM: '',
                errorMesM: '',
                errorAnoM: '',
                errorDireccionP: '',
                errorMunicipioDirP: '',
                errorTelefonoP: '',
                errorCorreoP: '',
                errorActividadP: '',
                errorDireccionM: '',
                errorMunicipioDirM: '',
                errorTelefonoM: '',
                errorCorreoM: '',
                errorActividadM: '',
                diaNaceP: null,
                mesNaceP: null,
                anoNaceP: null,
                diaNaceM: null,
                mesNaceM: null,
                anoNaceM: null,
                listaParentescos: [], 
                diaNaceA: null,
                mesNaceA: null,
                anoNaceA: null,
                errorDocumentoA: '',
                errorMunicipioDocA: '',
                errorNombresA: '',
                errorApellidosA: '',
                errorDiaA: '',
                errorMesA: '',
                errorAnoA: '',
                errorActividad: '',
                errorDireccionA: '',
                errorMunicipioDirA: '',
                errorTelefonoA: '',
                errorCorreoA: '',
                errorActividadA: '',
                errorParentesco: '',
                verFichaAcudiente: false,
                inhabilitarCampo: false,
                terminarMatricula: false,
                status: 'Aceptamos'
            }
        },
        methods: {
            async preMatricularEstudiante() {
                let datosPrematricula = {}
                datosPrematricula.id_matricula = this.$store.state.idMatriculaUsuario
                datosPrematricula.lectivo = this.$store.state.lectivoColegio
                datosPrematricula.bd = this.$store.state.bdColegio
                await axios
                .put(CONFIG.ROOT_PATH + "estudiantes/prematricula", JSON.stringify(datosPrematricula),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
                .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                    } else{
                        this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                    }
                })
                .catch(err => {
                    if (err.message === "Network Error")
                        this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
                    else
                        this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
                })                    

                this.terminarMatricula = true
            },
            async validarDatosAcudiente() {
                let datosValidos = true
                this.reseteoErroresAcudiente()
                if (document.getElementById('parentesco').value == '' || document.getElementById('parentesco').value == null){
                    this.errorParentesco = 'Seleccione el parentesco'
                    datosValidos = false
                }
                if (document.getElementById('documentoa').value == ''){
                    this.errorDocumentoA = 'Digite el documento'
                    datosValidos = false
                }
                if (document.getElementById('municipiodoca').value == '' || document.getElementById('municipiodoca').value == null){
                    this.errorMunicipioDocA = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('nombresa').value == ''){
                    this.errorNombresA = 'Digite los nombres'
                    datosValidos = false
                }
                if (document.getElementById('apellidosa').value == ''){
                    this.errorApellidosA = 'Digite los apellidos'
                    datosValidos = false
                }
                if (document.getElementById('diaA').value == '' || document.getElementById('diaA').value == null){
                    this.errorDiaA = 'Día'
                    datosValidos = false
                }
                if (document.getElementById('mesA').value == '' || document.getElementById('mesA').value == null){
                    this.errorMesA = 'Mes'
                    datosValidos = false
                }
                if (document.getElementById('anoA').value == '' || document.getElementById('anoA').value == null){
                    this.errorAnoA = 'Año'
                    datosValidos = false
                }
                if (document.getElementById('direccionA').value == ''){
                    this.errorDireccionA = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('municipiodirA').value == '' || document.getElementById('municipiodirA').value == null){
                    this.errorMunicipioDirA = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('telefonoA').value == ''){
                    this.errorTelefonoA = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('correoA').value == ''){
                    this.errorCorreoA = 'Digite el correo electrónico'
                    datosValidos = false
                }
                if (document.getElementById('actividadA').value == ''){
                    this.errorActividadA = 'Digite la actividad laboral - empresa'
                    datosValidos = false
                }
                if (!datosValidos){
                    this.mensajeEmergente('info','Mensaje','Aún hay datos sin digitar. Por favor diligencie el formulario totalmente.')
                    return false                   
                }
                if (datosValidos){
                    let datosFichaEstudiante = {}
                    datosFichaEstudiante.id_estudiante = this.datosEstudiante.id_estudiante
                    datosFichaEstudiante.id_nacionalidad = Number(this.datosEstudiante.id_nacionalidad)
                    datosFichaEstudiante.id_tipo_documento = this.datosEstudiante.id_tipo_documento
                    datosFichaEstudiante.id_municipio_documento = this.datosEstudiante.id_municipio_documento
                    datosFichaEstudiante.fecha_nacimiento = this.anoNace + "-" + this.mesNace + "-" + this.diaNace
                    datosFichaEstudiante.id_municipio_nacimiento = this.datosEstudiante.id_municipio_nacimiento
                    datosFichaEstudiante.id_genero = this.datosEstudiante.id_genero
                    datosFichaEstudiante.id_rh = this.datosEstudiante.id_rh
                    datosFichaEstudiante.id_etnia = this.datosEstudiante.id_etnia
                    datosFichaEstudiante.id_discapacidad = this.datosEstudiante.id_discapacidad
                    datosFichaEstudiante.id_capacidad = this.datosEstudiante.id_capacidad
                    datosFichaEstudiante.id_estrato = this.datosEstudiante.id_estrato
                    datosFichaEstudiante.sisben = this.datosEstudiante.sisben
                    datosFichaEstudiante.id_victima = this.datosEstudiante.id_victima
                    datosFichaEstudiante.eps = this.datosEstudiante.eps.toUpperCase().trim()
                    datosFichaEstudiante.enfermedades = this.datosEstudiante.enfermedades.toUpperCase().trim()
                    datosFichaEstudiante.direccion_estudiante = this.datosEstudiante.direccion_estudiante.trim()
                    datosFichaEstudiante.telefono_estudiante = this.datosEstudiante.telefono_estudiante.trim()
                    datosFichaEstudiante.correo_estudiante = this.datosEstudiante.correo_estudiante.toLowerCase().trim()
                    datosFichaEstudiante.id_municipio_direccion_estudiante = this.datosEstudiante.id_municipio_direccion_estudiante
                    if (this.datosEstudiante.id_genero == 1)
                        datosFichaEstudiante.foto = 'est_m.jpg'
                    else
                        datosFichaEstudiante.foto = 'est_f.jpg'
                    datosFichaEstudiante.documento_papa = this.datosEstudiante.documento_papa.trim()
                    datosFichaEstudiante.id_municipio_documento_papa = this.datosEstudiante.id_municipio_documento_papa
                    datosFichaEstudiante.nombres_papa = this.datosEstudiante.nombres_papa.toUpperCase().trim()
                    datosFichaEstudiante.apellidos_papa = this.datosEstudiante.apellidos_papa.toUpperCase().trim()
                    datosFichaEstudiante.fecha_nacimiento_papa = this.anoNaceP + "-" + this.mesNaceP + "-" + this.diaNaceP
                    datosFichaEstudiante.direccion_papa = this.datosEstudiante.direccion_papa.trim()
                    datosFichaEstudiante.id_municipio_direccion_papa = this.datosEstudiante.id_municipio_direccion_papa
                    datosFichaEstudiante.telefono_papa = this.datosEstudiante.telefono_papa.trim()
                    datosFichaEstudiante.correo_papa = this.datosEstudiante.correo_papa.toLowerCase().trim()
                    datosFichaEstudiante.actividad_papa = this.datosEstudiante.actividad_papa.toUpperCase().trim()
                    datosFichaEstudiante.documento_mama = this.datosEstudiante.documento_mama.trim()
                    datosFichaEstudiante.id_municipio_documento_mama = this.datosEstudiante.id_municipio_documento_mama
                    datosFichaEstudiante.nombres_mama = this.datosEstudiante.nombres_mama.toUpperCase().trim()
                    datosFichaEstudiante.apellidos_mama = this.datosEstudiante.apellidos_mama.toUpperCase().trim()
                    datosFichaEstudiante.fecha_nacimiento_mama = this.anoNaceM + "-" + this.mesNaceM + "-" + this.diaNaceM
                    datosFichaEstudiante.direccion_mama = this.datosEstudiante.direccion_mama.trim()
                    datosFichaEstudiante.id_municipio_direccion_mama = this.datosEstudiante.id_municipio_direccion_mama
                    datosFichaEstudiante.telefono_mama = this.datosEstudiante.telefono_mama.trim()
                    datosFichaEstudiante.correo_mama = this.datosEstudiante.correo_mama.toLowerCase().trim()
                    datosFichaEstudiante.actividad_mama = this.datosEstudiante.actividad_mama.toUpperCase().trim()
                    datosFichaEstudiante.documento_acudiente = this.datosEstudiante.documento_acudiente.trim()
                    datosFichaEstudiante.id_municipio_documento_acudiente = this.datosEstudiante.id_municipio_documento_acudiente
                    datosFichaEstudiante.nombres_acudiente = this.datosEstudiante.nombres_acudiente.toUpperCase().trim()
                    datosFichaEstudiante.apellidos_acudiente = this.datosEstudiante.apellidos_acudiente.toUpperCase().trim()
                    datosFichaEstudiante.fecha_nacimiento_acudiente = this.anoNaceA + "-" + this.mesNaceA + "-" + this.diaNaceA
                    datosFichaEstudiante.direccion_acudiente = this.datosEstudiante.direccion_acudiente.trim()
                    datosFichaEstudiante.id_municipio_direccion_acudiente = this.datosEstudiante.id_municipio_direccion_acudiente
                    datosFichaEstudiante.telefono_acudiente = this.datosEstudiante.telefono_acudiente.trim()
                    datosFichaEstudiante.correo_acudiente = this.datosEstudiante.correo_acudiente.toLowerCase().trim()
                    datosFichaEstudiante.actividad_acudiente = this.datosEstudiante.actividad_acudiente.toUpperCase().trim()
                    datosFichaEstudiante.id_parentesco = this.datosEstudiante.id_parentesco
                    datosFichaEstudiante.bd = this.$store.state.bdColegio
                    
                    await axios
                    .put(CONFIG.ROOT_PATH + "estudiantes", JSON.stringify(datosFichaEstudiante),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
                    .then(response => {
                        if (response.data.error){
                            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
                        } else{
                            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
                        }
                    })
                    .catch(err => {
                        if (err.message === "Network Error")
                            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
                        else
                            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
                    })                    
                }
                return true
            },
            reseteoCamposAcudiente() {
                this.errorParentesco = ''
                this.datosEstudiante.documento_acudiente = ''
                this.datosEstudiante.id_municipio_documento_acudiente = null
                this.datosEstudiante.nombres_acudiente = ''
                this.datosEstudiante.apellidos_acudiente = ''
                this.diaNaceA = null
                this.mesNaceA = null
                this.anoNaceA = null
                this.datosEstudiante.direccion_acudiente = ''
                this.datosEstudiante.id_municipio_direccion_acudiente = null
                this.datosEstudiante.telefono_acudiente = ''
                this.datosEstudiante.correo_acudiente = ''
                this.datosEstudiante.actividad_acudiente = ''
            },
            validarParentesco() {
                this.verFichaAcudiente = true
                this.reseteoErroresAcudiente()
                this.datosEstudiante.id_parentesco = document.getElementById('parentesco').value
                if (document.getElementById('parentesco').value == 1) {
                    this.datosEstudiante.documento_acudiente = this.datosEstudiante.documento_papa
                    this.datosEstudiante.id_municipio_documento_acudiente = this.datosEstudiante.id_municipio_documento_papa
                    this.datosEstudiante.nombres_acudiente = this.datosEstudiante.nombres_papa
                    this.datosEstudiante.apellidos_acudiente = this.datosEstudiante.apellidos_papa
                    this.diaNaceA = this.diaNaceP
                    this.mesNaceA = this.mesNaceP
                    this.anoNaceA = this.anoNaceP
                    this.datosEstudiante.direccion_acudiente = this.datosEstudiante.direccion_papa
                    this.datosEstudiante.id_municipio_direccion_acudiente = this.datosEstudiante.id_municipio_direccion_papa
                    this.datosEstudiante.telefono_acudiente = this.datosEstudiante.telefono_papa
                    this.datosEstudiante.correo_acudiente = this.datosEstudiante.correo_papa
                    this.datosEstudiante.actividad_acudiente = this.datosEstudiante.actividad_papa
                    this.inhabilitarCampo = true
                } else if (document.getElementById('parentesco').value == 2) {
                    this.datosEstudiante.documento_acudiente = this.datosEstudiante.documento_mama
                    this.datosEstudiante.id_municipio_documento_acudiente = this.datosEstudiante.id_municipio_documento_mama
                    this.datosEstudiante.nombres_acudiente = this.datosEstudiante.nombres_mama
                    this.datosEstudiante.apellidos_acudiente = this.datosEstudiante.apellidos_mama
                    this.diaNaceA = this.diaNaceM
                    this.mesNaceA = this.mesNaceM
                    this.anoNaceA = this.anoNaceM
                    this.datosEstudiante.direccion_acudiente = this.datosEstudiante.direccion_mama
                    this.datosEstudiante.id_municipio_direccion_acudiente = this.datosEstudiante.id_municipio_direccion_mama
                    this.datosEstudiante.telefono_acudiente = this.datosEstudiante.telefono_mama
                    this.datosEstudiante.correo_acudiente = this.datosEstudiante.correo_mama
                    this.datosEstudiante.actividad_acudiente = this.datosEstudiante.actividad_mama
                    this.inhabilitarCampo = true
                } else if (document.getElementById('parentesco').value > 2) {
                    this.inhabilitarCampo = false
                } else {
                    this.verFichaAcudiente = false
                }
            },
            async validarDatosFamiliares() {
                let datosValidos = true
                this.reseteoErroresFamiliares()
                if (document.getElementById('documentop').value == ''){
                    this.errorDocumentoP = 'Digite el documento'
                    datosValidos = false
                }
                if (document.getElementById('documentom').value == ''){
                    this.errorDocumentoM = 'Digite el documento'
                    datosValidos = false
                }
                if (document.getElementById('municipiodocp').value == '' || document.getElementById('municipiodocp').value == null){
                    this.errorMunicipioDocP = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('municipiodocm').value == '' || document.getElementById('municipiodocm').value == null){
                    this.errorMunicipioDocM = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('nombresp').value == ''){
                    this.errorNombresP = 'Digite los nombres'
                    datosValidos = false
                }
                if (document.getElementById('nombresm').value == ''){
                    this.errorNombresM = 'Digite los nombres'
                    datosValidos = false
                }
                if (document.getElementById('apellidosp').value == ''){
                    this.errorApellidosP = 'Digite los apellidos'
                    datosValidos = false
                }
                if (document.getElementById('apellidosm').value == ''){
                    this.errorApellidosM = 'Digite los apellidos'
                    datosValidos = false
                }
                if (document.getElementById('diaP').value == '' || document.getElementById('diaP').value == null){
                    this.errorDiaP = 'Día'
                    datosValidos = false
                }
                if (document.getElementById('mesP').value == '' || document.getElementById('mesP').value == null){
                    this.errorMesP = 'Mes'
                    datosValidos = false
                }
                if (document.getElementById('anoP').value == '' || document.getElementById('anoP').value == null){
                    this.errorAnoP = 'Año'
                    datosValidos = false
                }
                if (document.getElementById('diaM').value == '' || document.getElementById('diaM').value == null){
                    this.errorDiaM = 'Día'
                    datosValidos = false
                }
                if (document.getElementById('mesM').value == '' || document.getElementById('mesM').value == null){
                    this.errorMesM = 'Mes'
                    datosValidos = false
                }
                if (document.getElementById('anoM').value == '' || document.getElementById('anoM').value == null){
                    this.errorAnoM = 'Año'
                    datosValidos = false
                }
                if (document.getElementById('direccionP').value == ''){
                    this.errorDireccionP = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('municipiodirP').value == '' || document.getElementById('municipiodirP').value == null){
                    this.errorMunicipioDirP = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('telefonoP').value == ''){
                    this.errorTelefonoP = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('correoP').value == ''){
                    this.errorCorreoP = 'Digite el correo electrónico'
                    datosValidos = false
                }
                if (document.getElementById('actividadP').value == ''){
                    this.errorActividadP = 'Digite la actividad laboral - empresa'
                    datosValidos = false
                }
                if (document.getElementById('direccionM').value == ''){
                    this.errorDireccionM = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('municipiodirM').value == '' || document.getElementById('municipiodirM').value == null){
                    this.errorMunicipioDirM = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('telefonoM').value == ''){
                    this.errorTelefonoM = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('correoM').value == ''){
                    this.errorCorreoM = 'Digite el correo electrónico'
                    datosValidos = false
                }
                if (document.getElementById('actividadM').value == ''){
                    this.errorActividadM = 'Digite la actividad laboral - empresa'
                    datosValidos = false
                }

                if (!datosValidos){
                    this.mensajeEmergente('info','Mensaje','Aún hay datos sin digitar. Por favor diligencie el formulario totalmente.')
                    return false                   
                }
                if (datosValidos){
                    this.validarParentesco()
                }
                return true
            },
            async validarDatosEstudiante() {
                let datosValidos = true
                this.reseteoErroresEstudiante()
                if (document.getElementById('nacionalidad').value == '' || document.getElementById('nacionalidad').value == null){
                    this.errorNacionalidad = 'Seleccione un país'
                    datosValidos = false
                }
                if (document.getElementById('tipo').value == '' || document.getElementById('tipo').value == null){
                    this.errorTipo = 'Seleccione un tipo'
                    datosValidos = false
                }
                if (document.getElementById('municipiodoc').value == '' || document.getElementById('municipiodoc').value == null){
                    this.errorMunicipioDoc = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('dia').value == '' || document.getElementById('dia').value == null){
                    this.errorDia = 'Día'
                    datosValidos = false
                }
                if (document.getElementById('mes').value == '' || document.getElementById('mes').value == null){
                    this.errorMes = 'Mes'
                    datosValidos = false
                }
                if (document.getElementById('ano').value == '' || document.getElementById('ano').value == null){
                    this.errorAno = 'Año'
                    datosValidos = false
                }
                if (document.getElementById('municipionac').value == '' || document.getElementById('municipionac').value == null){
                    this.errorMunicipioNac = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('genero').value == '' || document.getElementById('genero').value == null){
                    this.errorGenero = 'Seleccione un genero'
                    datosValidos = false
                }
                if (document.getElementById('rh').value == '' || document.getElementById('rh').value == null){
                    this.errorRh = 'Seleccione un rh'
                    datosValidos = false
                }
                if (document.getElementById('etnia').value == '' || document.getElementById('etnia').value == null){
                    this.errorEtnia = 'Seleccione una etnia'
                    datosValidos = false
                }
                if (document.getElementById('limitacion').value == '' || document.getElementById('limitacion').value == null){
                    this.errorLimitacion = 'Seleccione una limitación o discapacidad'
                    datosValidos = false
                }
                if (document.getElementById('capacidad').value == '' || document.getElementById('capacidad').value == null){
                    this.errorCapacidad = 'Seleccione una capacidad excepcional'
                    datosValidos = false
                }
                if (document.getElementById('estrato').value == '' || document.getElementById('estrato').value == null){
                    this.errorEstrato = 'Seleccione un estrato'
                    datosValidos = false
                }
                if (document.getElementById('sisben').value == ''){
                    this.errorSisben = 'Digite el puntaje en el sisben'
                    datosValidos = false
                }
                if (document.getElementById('victima').value == '' || document.getElementById('victima').value == null){
                    this.errorVictima = 'Seleccione la situación de victima'
                    datosValidos = false
                }
                if (document.getElementById('eps').value == ''){
                    this.errorEps = 'Digite la EPS'
                    datosValidos = false
                }
                if (document.getElementById('enfermedad').value == ''){
                    this.errorEnfermedad = 'Digite si tiene alguna enfermedad, tratamiento especial o alergia'
                    datosValidos = false
                }
                if (document.getElementById('direccionE').value == ''){
                    this.errorDireccionE = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('municipiodirE').value == '' || document.getElementById('municipiodirE').value == null){
                    this.errorMunicipioDirE = 'Seleccione un municipio'
                    datosValidos = false
                }
                if (document.getElementById('telefonoE').value == ''){
                    this.errorTelefonoE = 'Digite la direccion de residencia'
                    datosValidos = false
                }
                if (document.getElementById('correoE').value == ''){
                    this.errorCorreoE = 'Digite el correo electrónico'
                    datosValidos = false
                }
                if (!datosValidos){
                    this.mensajeEmergente('info','Mensaje','Aún hay datos sin digitar. Por favor diligencie el formulario totalmente.')
                    return false                   
                }
                return true
            },
            onComplete: function(){
                this.$router.push("/")
            },
            reseteoErroresAcudiente() {
                this.errorParentesco = ''
                this.errorDocumentoA = ''
                this.errorMunicipioDocA = ''
                this.errorNombresA = ''
                this.errorApellidosA = ''
                this.errorDiaA = ''
                this.errorMesA = ''
                this.errorAnoA = ''
                this.errorDireccionA = ''
                this.errorMunicipioDirA = ''
                this.errorTelefonoA = ''
                this.errorCorreoA = ''
                this.errorActividadA = ''
            },
            reseteoErroresFamiliares() {
                this.errorDocumentoP = ''
                this.errorDocumentoM = ''
                this.errorMunicipioDocP = ''
                this.errorMunicipioDocM = ''
                this.errorNombresP = ''
                this.errorNombresM = ''
                this.errorApellidosP = ''
                this.errorApellidosM = ''
                this.errorDiaP = ''
                this.errorMesP = ''
                this.errorAnoP = ''
                this.errorDiaM = ''
                this.errorMesM = ''
                this.errorAnoM = ''
                this.errorDireccionP = ''
                this.errorMunicipioDirP = ''
                this.errorTelefonoP = ''
                this.errorCorreoP = ''
                this.errorActividadP = ''
                this.errorDireccionM = ''
                this.errorMunicipioDirM = ''
                this.errorTelefonoM = ''
                this.errorCorreoM = ''
                this.errorActividadM = ''
            },
            reseteoErroresEstudiante() {
                this.errorNombresE = ''
                this.errorApellidosE = ''
                this.errorNacionalidad = ''
                this.errorDocumentoE = ''
                this.errorTipo = ''
                this.errorMunicipioDoc = ''
                this.errorDia = ''
                this.errorMes = ''
                this.errorAno = ''
                this.errorMunicipioNac = ''
                this.errorGenero = ''
                this.errorRh = ''
                this.errorEtnia = ''
                this.errorLimitacion = ''
                this.errorVictima = ''
                this.errorCapacidad = ''
                this.errorEstrato = ''
                this.errorSisben = ''
                this.errorEps = ''
                this.errorEnfermedad = ''
                this.errorDireccionE = ''
                this.errorMunicipioDirE = ''
                this.errorTelefonoE = ''
                this.errorCorreoE = ''
            },
            async consultarEstudiante() {
                await axios
                .get(CONFIG.ROOT_PATH + 'estudiantes', { params: { bd: this.$store.state.bdColegio, id: this.$store.state.idUsuario }})
                .then(response => {
                    if (response.data.error){
                        this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
                    } else{
                        this.datosEstudiante = response.data.datos
                        this.diaNace = Number(this.datosEstudiante.fecha_nacimiento.substr(8,2))
                        this.mesNace = Number(this.datosEstudiante.fecha_nacimiento.substr(5,2))
                        this.anoNace = Number(this.datosEstudiante.fecha_nacimiento.substr(0,4))
                        this.diaNaceP = Number(this.datosEstudiante.fecha_nacimiento_papa.substr(8,2))
                        this.mesNaceP = Number(this.datosEstudiante.fecha_nacimiento_papa.substr(5,2))
                        this.anoNaceP = Number(this.datosEstudiante.fecha_nacimiento_papa.substr(0,4))
                        this.diaNaceM = Number(this.datosEstudiante.fecha_nacimiento_mama.substr(8,2))
                        this.mesNaceM = Number(this.datosEstudiante.fecha_nacimiento_mama.substr(5,2))
                        this.anoNaceM = Number(this.datosEstudiante.fecha_nacimiento_mama.substr(0,4))
                        this.diaNaceA = Number(this.datosEstudiante.fecha_nacimiento_mama.substr(8,2))
                        this.mesNaceA = Number(this.datosEstudiante.fecha_nacimiento_mama.substr(5,2))
                        this.anoNaceA = Number(this.datosEstudiante.fecha_nacimiento_mama.substr(0,4))
                    }
                })
                .catch(err => {
                    if (err.message === 'Network Error')
                        this.mensajeEmergente('danger','Mensaje','Conexión denegada!. Por favor contáctese con el administrador.')
                    else
                        this.mensajeEmergente('danger','Mensaje','Se ha detectado un error inesperado!. Por favor contáctese con el administrador.' + err.message);
                })
            },
            iniciarListas() {
                paises.forEach(element => {
                    this.listaPaises.push({ 'value': element.numericCode, 'text': element.name.toUpperCase() })
                })
                municipios.forEach(element => {
                    this.listaMunicipios.push({ 'value': element.id, 'text': element.municipio.toUpperCase() + ' - ' + element.departamento.toUpperCase() })
                })
                this.listaMunicipios.sort(function (a, b) {
                    if (a.text > b.text) {
                        return 1
                    }
                    if (a.text < b.text) {
                        return -1
                    }
                    return 0
                })
                this.listaMunicipios.push({'text': '* MUNICIPIO EN OTRA NACIONALIDAD', 'value': '99999' })
                for (var i = 1; i <= 31; i++) {
                    this.listaDias.push({ 'value': i, 'text': i })
                }
                let fecha = new Date()
                let ano = fecha.getFullYear()
                for (var i = ano - 1; i > ano - 70; i--) {
                    this.listaAnos.push({ 'value': i, 'text': i })
                }
                documentos.forEach(element => {
                    this.listaTiposDocumentos.push({ 'value': element.id, 'text': element.nemo.toUpperCase() + ' - ' + element.documento.toUpperCase() })
                })
                generos.forEach(element => {
                    this.listaGeneros.push({ 'value': element.id, 'text': element.genero.toUpperCase() })
                })
                rhs.forEach(element => {
                    this.listaRhs.push({ 'value': element.id, 'text': element.rh.toUpperCase() })
                })
                etnias.forEach(element => {
                    this.listaEtnias.push({ 'value': element.id, 'text': element.etnia.toUpperCase() })
                })
                limitaciones.forEach(element => {
                    this.listaLimitaciones.push({ 'value': element.id, 'text': element.limitacion.toUpperCase() })
                })
                victimas.forEach(element => {
                    this.listaVictimas.push({ 'value': element.id, 'text': element.victima.toUpperCase() })
                })
                for (var i = 1; i <= 6; i++) {
                    this.listaEstratos.push({ 'value': i, 'text': i })
                }
                parentescos.forEach(element => {
                    this.listaParentescos.push({ 'value': element.id, 'text': element.parentesco.toUpperCase() })
                })
            },
            mensajeEmergente(variante, titulo, contenido) {
                this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
            }
        },
        beforeMount() {
            this.iniciarListas()
            this.consultarEstudiante()
        }
    }
</script>